import { FEATURE_FLAGS, useFeatureFlags } from "@src/services/feature-flags/feature-flags";
import { LegacyAlarmsScreen } from "@src/features/alarms/screens/LegacyAlarmsTab.native";
import { SiteWideAlarmsScreen } from "@src/features/alarms/screens/SiteWideAlarmsTab.native";

export default function AlarmsScreen() {
  const { getBooleanFlag } = useFeatureFlags();
  const siteWideControlsEnabled = getBooleanFlag(FEATURE_FLAGS.SITE_WIDE_CONTROLS);

  return siteWideControlsEnabled ? <SiteWideAlarmsScreen /> : <LegacyAlarmsScreen />;
}
